import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../ui/alert-dialog';
import { P } from '../ui/typography';

interface AvailabilityClashAlertProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function AvailabilityClashAlert({ open, onOpenChange }: AvailabilityClashAlertProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Your availability request clashes with a job you have accepted</AlertDialogTitle>
          <AlertDialogDescription>
            Please contact the office if you are not longer able to work the job and want to book the time off.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onPress={() => onOpenChange(false)}>
            <P className="text-white">Cancel</P>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}